import { render } from "./PackageSelect.vue?vue&type=template&id=27a622f4&scoped=true"
import script from "./PackageSelect.vue?vue&type=script&lang=js"
export * from "./PackageSelect.vue?vue&type=script&lang=js"

import "./PackageSelect.vue?vue&type=style&index=0&id=27a622f4&lang=scss&scoped=true"
import "./PackageSelect.vue?vue&type=style&index=1&id=27a622f4&lang=scss"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a622f4"]])

export default __exports__